import { render, staticRenderFns } from "./StoreFavorite.vue?vue&type=template&id=804f339e&"
import script from "./StoreFavorite.vue?vue&type=script&lang=js&"
export * from "./StoreFavorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports